import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "../../App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "../navigation/Navbar";
import Profile from "./Profile";
import LoginButton from "./LoginButton";
import FixedBottomNavigation from "../navigation/BottomNav";

interface LoginProps {
  setToken: (token: any) => void;
}

export default function Login({ setToken }: LoginProps): React.JSX.Element {
  return (
    <div style={{ height: "100vh" }}>
      <Navbar />
      <Profile />
      <Grid container component="main">
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url(background.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          sx={{ boxShadow: 0 }}
          component={Paper}
          elevation={6}
          square
        >
          <Box
            sx={{
              my: -8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100vh",
              justifyContent: "center",
            }}
          >
            <Typography
              component="h1"
              variant="h1"
              style={{ fontFamily: "SigmaSans", marginBottom: "40px" }}
            >
              Yard Manager
            </Typography>
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <Routes>
                <Route path="/" element={<LoginButton />} />
              </Routes>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <FixedBottomNavigation />
    </div>
  );
}
